<template>
  <div>
    <h2>Rymy</h2>
    <el-card class="box-card text" v-for="(rhym, index) in rhyme" :key="index">
        <q v-html="renderText(rhym)"></q>
        <div class="buttons">
          <el-button type="success" @click="createText(rhym)" size="mini">Dodaj</el-button>
          <el-button type="primary" @click="setText(rhym)" size="mini">Wybieram</el-button>
        </div>
    </el-card>
  </div>
</template>

<script>
  import Editor from '../../classes/Editor'
  
  export default {
    data() {
      return {
        rhyme: [
          'Bardzo chcemy wszystkich prosić, by nam kwiatów nie przynosić.\nStąd wiadomo ku publice chcemy z winem mieć piwnice.\nNiekoniecznie z winnic znanych, za to przez wielu lubianych,\nwino włoskie, bądź też z Chile, co zapewnia miłe chwile.',
          '„Mili Goście, kwiatów nam nie przynoście.\nKwiatuszki bardzo lubimy,\njednak o butelkę wina prosimy” Kwiatki choć piękne alergię wzmagają.',
          'Misie pluszowe kurzem osiadają.\nW zamian o wytrawne wino chcielibyśmy prosić,\nktórym zdrowie gości\njesiennym wieczorem będziemy wznosić.',
          'Istnieje zwyczaj przychodzenia z bukietami,\nlecz my słodyczy jesteśmy smakoszami,\nwięc jeśli macie ochotę podarować nam kwiatki,\nprzynieście zamiast nich wino lub czekoladki.',
          'Zamiast kwiatów do wazonów,\nKtóre uschną w naszym domu,\nPropozycje mamy taką:\nByśmy razem wino pili, konwenanse odrzucili,\nNiechaj rosną nam kwiateczki,\nWy przynieście wina z beczki.',
          'Zamiast kwiatków do wazonu, które uschną w naszym domu,\nGoście Drodzy, Goście Mili, propozycję mamy taką:\nRadość byście nam sprawili, zatrzymując czar tej chwili\nNie kupujcie kwiatka z wstążką – obdarujcie jakąś książką\nPodpisując z wielką gracją osobistą dedykacją\nAlbo dobre wino w darze na pomyślność Młodej Parze',
          'Nasi Kochani Goście\nKwiatków nam nie przynoście\nwolimy dostać flaszeczkę wina\nbędzie się cieszyć cała rodzina.',
          'Prosimy kwiatów nam nie kupować,\nlecz butelką wina nas obdarować.',
          'Nasi Kochani Goście\nKwiatków nam nie przynoście\nwolimy dostać flaszeczkę wina\nbędzie się cieszyć cała rodzina',
          'Prosimy Was Nasi Mili\nAbyście zamiast kwiatków nam wino sprawili\nWina wytrawne, czerwone i białe\nUmilą nam wspólne chwile wspaniałe',
        ]
      };
    },
    methods: {
      setText(rhym) {
        if (! Editor.canvas.getActiveObject()) {
          this.$alert('Wybierz pole tekstowe w którym wstawić wybrany tekst.', 'Ups...', {
            confirmButtonText: 'OK',
            type: 'warning',
          });
        } else {
          Editor.setText(rhym);
        }
      },
      createText(text) {
        Editor.addText(text, {
          textAlign: 'center',
          fontSize: 16,
          width: 400
        });
      },
      renderText(text) {
        return text.replace(/\\n/g, '<br />');
      }
    }
  }
</script>

<style lang="less">
  .box-card {
    &.text {
      .el-card__body {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .buttons {
        margin-top: 15px;
      }
      + .text {
        margin-top: 15px;
      }
      q {
        width: 100%;
        font-size: 10px;
        text-align: center;
      }
    }
  }
</style>